export const toSentenceCase = (phrase: string) =>
  phrase
    .toLowerCase()
    .replace(/(^|\s)([a-z])/g, it => it.toUpperCase())
    .replace(/Gp\b/, 'GP')
    .replace(/Ent\b/, 'ENT');

export const hyphenEncode = (input: string) =>
  input
    .split('-')
    .map(it => it.replace(/ /g, '-'))
    .join('--');

export const hyphenDecode = (input: string) =>
  input
    .split('--')
    .map(it => it.replace(/[-_]/g, ' '))
    .map(it => it.replace(/\s+/g, ' '))
    .join('-');
